export default async function GetDealWiseInvestor() {
    let url = window.RealestateService+  `/api/PaymentDetails/GetDealWiseInvestorPaymentDetails`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}